import { Link } from 'react-router-dom';
import { Reveal } from '../ui';
import { PILLARS, type Pillar } from './homeData';

/**
 * C9 pillar photo cards: three flat columns (photo 4:3 with a subtle zoom on
 * hover, H3, two or three lines), the whole card one link. Stack on phones.
 * Reused by Services (import PILLARS or pass your own items).
 */

const SIZES = '(max-width: 767px) 100vw, (max-width: 1023px) 45vw, 340px';

export default function PillarCards({ items = PILLARS, className = '' }: { items?: Pillar[]; className?: string }) {
  return (
    <Reveal group className={`ve-home-pillars ${className}`.trim()}>
      {items.map((p) => (
        <Link key={p.to} to={p.to} className="ve-home-pillar">
          <span className="ve-photo-frame ve-photo-frame--4x3">
            <img
              src={p.image.src}
              srcSet={p.image.srcSet}
              sizes={SIZES}
              alt={p.image.alt}
              width={p.image.width}
              height={p.image.height}
              loading="lazy"
              decoding="async"
              style={p.image.focal ? { objectPosition: p.image.focal } : undefined}
            />
          </span>
          <h3 className="ve-home-pillar-title">{p.title}</h3>
          <p className="ve-home-pillar-text">{p.text}</p>
        </Link>
      ))}
    </Reveal>
  );
}
